import OffersSection from './OffersSection'
export { default as OfferBanner } from './OfferBanner'

export default OffersSection
